module.exports = __webpack_public_path__ + "static/media/8.eafdeaa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/8.png
// module id = 485
// module chunks = 0